import React from "react";
import Header from "../../../components/ui/Header";
import Footer from "../../../components/ui/Footer";
import WhatsAppButton from "../../../components/ui/WhatsAppButton";

const AstrologicServices = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 w-full pt-20 pb-16 px-5 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">

                {/* IMAGEN – arriba en móvil */}
                <div className="md:w-1/2 flex justify-center order-1 md:order-2">
                    <img
                        src="/assets/images/astrologic-services.jpg"
                        alt="Astrologic Services"
                        className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-full"
                    />
                </div>

                {/* TEXTO */}
                <div className="md:w-1/2 space-y-5 order-2 md:order-1">

                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-headline font-bold text-indigo-900 leading-tight">
                        SERVICIOS ASTROLÓGICOS
                        <span className="block w-20 h-1 bg-purple-400 rounded-full mt-3"></span>
                    </h1>

                    <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
                        Rosa Maria Cifuentes ofrece una gama de servicios especializados
                        en astrología y desarrollo personal diseñados para brindar claridad,
                        orientación y crecimiento personal.
                    </p>

                    <ul className="space-y-3 text-gray-800 text-sm md:text-base leading-relaxed">
                        <li>
                            <span className="font-semibold text-primary">Carta Natal:</span>{" "}
                            Estudio del momento del nacimiento que revela personalidad, vocación y salud.
                        </li>
                        <li>
                            <span className="font-semibold text-primary">Revolución Solar:</span>{" "}
                            Carta predictiva anual con eventos y aprendizajes del año.
                        </li>
                        <li>
                            <span className="font-semibold text-primary">Astro Terapia:</span>{" "}
                            Terapia emocional guiada por el lenguaje de los astros.
                        </li>
                        <li>
                            <span className="font-semibold text-primary">Revolución Lunar:</span>{" "}
                            Mapa emocional mensual para guiar decisiones importantes.
                        </li>
                        <li>
                            <span className="font-semibold text-primary">Sinastría y Carta Compuesta:</span>{" "}
                            Compatibilidad emocional y energética entre parejas.
                        </li>
                        <li>
                            <span className="font-semibold text-primary">Astrología Kármica:</span>{" "}
                            Comprensión de las lecciones heredadas de vidas pasadas.
                        </li>
                    </ul>

                    <p className="text-base md:text-lg font-semibold text-indigo-900 text-justify">
                        ¡Contáctanos hoy mismo y descubre cómo podemos ayudarte a transformar tu vida con
                        soluciones astrológicas personalizadas!
                    </p>
                </div>

                <WhatsAppButton />
            </main>

            <Footer />
        </div>
    );

};

export default AstrologicServices;